import { useId } from 'react';

import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const Quiz = ({ color, size, title, titleId, aphroditeStyles = [] }: Props) => {
  const maskId = useId();
  return (
    <Icon
      color={color}
      size={size}
      aphroditeStyles={aphroditeStyles}
      title={title}
      titleId={titleId}
      viewBoxWidth={41}
      viewBoxHeight={40}
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="41"
        height="40"
      >
        <rect x="0.5" width="40" height="40" fill="white" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M23.0722 25.0213C23.4833 25.0213 23.8375 24.8737 24.1347 24.5784C24.4322 24.2834 24.5809 23.9301 24.5809 23.5184C24.5809 23.1067 24.4322 22.7533 24.1347 22.458C23.8375 22.1627 23.4833 22.0151 23.0722 22.0151C22.6613 22.0151 22.3072 22.1627 22.0097 22.458C21.7125 22.7533 21.5638 23.1067 21.5638 23.5184C21.5638 23.9301 21.7125 24.2834 22.0097 24.5784C22.3072 24.8737 22.6613 25.0213 23.0722 25.0213ZM23.0551 20.0534C23.2887 20.0534 23.4893 19.974 23.6568 19.8151C23.824 19.6565 23.9301 19.4563 23.9751 19.2147C24.0306 18.8052 24.1701 18.4311 24.3934 18.0922C24.6168 17.753 25.0062 17.3256 25.5618 16.8101C26.3009 16.114 26.8094 15.5092 27.0872 14.9959C27.365 14.4823 27.5038 13.8826 27.5038 13.1967C27.5038 11.9954 27.0851 11.0059 26.2476 10.2284C25.4098 9.45091 24.3308 9.06216 23.0105 9.06216C22.1691 9.06216 21.3966 9.2598 20.693 9.65508C19.9894 10.0504 19.4225 10.6098 18.9922 11.3334C18.8761 11.5295 18.864 11.7374 18.9559 11.9572C19.0479 12.1766 19.2081 12.3398 19.4368 12.4467C19.6554 12.542 19.8766 12.5505 20.1005 12.4722C20.3241 12.3941 20.5052 12.2574 20.6438 12.0622C20.938 11.6099 21.2819 11.2772 21.6755 11.0638C22.0691 10.8505 22.5141 10.7438 23.0105 10.7438C23.8125 10.7438 24.4748 10.9788 24.9976 11.4488C25.5204 11.9188 25.7818 12.5206 25.7818 13.2542C25.7818 13.7392 25.6569 14.1811 25.4072 14.5797C25.1575 14.9783 24.7147 15.4467 24.0788 15.9851C23.4527 16.5106 23.0015 17.0213 22.7251 17.5172C22.4487 18.013 22.2791 18.5742 22.2163 19.2009C22.1958 19.4181 22.2675 19.6145 22.4313 19.7901C22.5952 19.9656 22.8031 20.0534 23.0551 20.0534ZM12.7113 29.9788C11.995 29.9788 11.3813 29.7234 10.8705 29.2126C10.3597 28.7017 10.1043 28.0881 10.1043 27.3717V6.77383C10.1043 6.05744 10.3597 5.44383 10.8705 4.933C11.3813 4.42217 11.995 4.16675 12.7113 4.16675H33.3093C34.0256 4.16675 34.6393 4.42217 35.1501 4.933C35.6609 5.44383 35.9163 6.05744 35.9163 6.77383V27.3717C35.9163 28.0881 35.6609 28.7017 35.1501 29.2126C34.6393 29.7234 34.0256 29.9788 33.3093 29.9788H12.7113ZM7.69009 35.0001C6.9737 35.0001 6.36009 34.7447 5.84926 34.2338C5.33842 33.723 5.08301 33.1094 5.08301 32.393V10.748C5.08301 10.4461 5.18204 10.1961 5.38009 9.998C5.57842 9.79994 5.82842 9.70092 6.13009 9.70092C6.43204 9.70092 6.68204 9.79994 6.88009 9.998C7.07815 10.1961 7.17717 10.4461 7.17717 10.748V32.393C7.17717 32.5213 7.23051 32.639 7.33717 32.7459C7.44412 32.8526 7.56176 32.9059 7.69009 32.9059H29.3351C29.637 32.9059 29.887 33.0049 30.0851 33.203C30.2831 33.4013 30.3822 33.6513 30.3822 33.953C30.3822 34.2549 30.2831 34.5049 30.0851 34.703C29.887 34.9011 29.637 35.0001 29.3351 35.0001H7.69009Z"
          fill={color}
        />
      </g>
    </Icon>
  );
};

Quiz.displayName = 'Quiz';

export default Quiz;
